<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="indigo" icon="mdi-content-copy" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Predefined stocks</div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" @click="createItem">New item</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto"
              label="Search"
              hide-details
              single-line
              style="max-width: 250px;"
            />
          </v-toolbar>
          <v-divider class="mt-3" />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" @click="editItem(item)">mdi-lead-pencil</v-icon>
          <v-icon @click="dialog = true">mdi-delete</v-icon>
          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">Are you sure?</v-card-title>
              <v-card-actions>
                
                <v-btn color="green darken-1" text @click="dialog = false">No</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click=" deleteItem(item)">Yes</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </base-material-card>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import axios from "../../../../utils/axios";
export default {
  name: "PredefinedStocks",

  data: () => ({
    headers: [
      {
        text: "Name",
        value: "name"
      },
      {
        text: "Amount of articles",
        value: "productQuantities.length"
      },
      {
        text: "Total value",
        value: "totalValue"
      },
      {
        text: "Total in value",
        value: "totalInValue"
      },
      {
        sortable: false,
        text: "Actions",
        value: "actions"
      }
    ],
    items: [],
    search: undefined,
    snackbar: false,
    dialog: false,
    message: "",
    snackColor: "error"
  }),

  created() {
    this.init();
  },

  methods: {
    editItem(item) {
        let id = item.id;
        this.$router.push({ path: `Edit/${id}` });
    },

    createItem() {
      this.$router.push({ path: "Create" });
    },

    async deleteItem(item) {
      this.dialog = false;
      let loader = this.$loading.show();
      try {
        var result = await axios.delete(
          "/PreDefinedConsignmentStock/" + item.id
        );
        if (result) {
          await this.getPredefinedStocks();
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = exception;
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    },

    init() {
      this.getPredefinedStocks();
    },
    async getPredefinedStocks() {
      let loader = this.$loading.show();
      try {
        var result = await axios.get("/PreDefinedConsignmentStock");
        if (result) {
          this.items = result.data;
        } else {
          throw "Unknown error";
        }
      } catch (exception) {
        this.message = exception;
        this.snackbar = true;
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
